/**
 * Datetime utilities for the billing pricing admin UI.
 *
 * Shared between AddVersionModal and CloseVersionDialog (DRY) and replaces
 * the previously duplicated `toIsoFromLocalDate` helpers that hardcoded a
 * `+02:00` Europe/Warsaw summer offset (DST-naive — broken in winter).
 *
 * @see docs/specifications/2026-05-05-billing-pricing-admin-ui/reviews/consolidated.md
 *      ([Code Quality/UX] DRY violation: toIsoFromLocalDate)
 */

/**
 * Convert a `<input type="datetime-local">` value (`"YYYY-MM-DDTHH:MM"`) to
 * ISO 8601 with the browser's local timezone offset.
 *
 * `new Date(localValue)` parses `datetime-local` strings as **local** time
 * (browser's timezone). For Polish admins this is Europe/Warsaw, so DST is
 * handled automatically by the runtime. The returned value is UTC ISO 8601
 * (`...Z`), which the backend stores as a `timestamp with time zone`.
 *
 * @param localValue - Value from `<input type="datetime-local">`, or empty string.
 * @returns ISO 8601 UTC string, or `""` for empty/invalid input.
 */
export function toIsoFromLocalDate(localValue: string): string {
  if (!localValue) return "";
  const date = new Date(localValue);
  if (isNaN(date.getTime())) return "";
  return date.toISOString();
}
